import { useCallback } from 'react'

import { type ReferenceImageItem,refreshReferenceImageUrlByObjectKey } from '../api/referenceImages'
import { useImageLightbox } from '../context/ImageLightboxContext'
import { useTheme } from '../theme/ThemeContext'
import { type ImageLightboxItem } from './ImageLightbox'
import { ImageLightbox } from './ImageLightbox'

/**
 * 图片灯箱宿主：挂载于路由之上的 Provider 内，不随页面切换卸载，
 * 因此弹窗的 open 状态与内容在切换页面后得以保留。
 * angular 由当前主题推导，与页面内一致。
 */
export function ImageLightboxHost() {
  const { isOpen, items, index, setIndex, close } = useImageLightbox()
  const { theme } = useTheme()
  const angular = theme === 'pixel' || theme === 'geek'

  /**
   * 图库条目（带 objectKey）的「加载失败自愈」：
   * 灯箱不再主动重签——点得开即说明列表签名有效；仅当大图真正加载失败时才用 objectKey 换一份新签名重试。
   */
  const refreshImageUrl = useCallback(
    async (item: ImageLightboxItem): Promise<ReferenceImageItem | null> => {
      const key = item.objectKey?.trim()
      if (!key) return null
      try {
        return await refreshReferenceImageUrlByObjectKey(key)
      } catch {
        return null
      }
    },
    [],
  )

  return (
    <ImageLightbox
      open={isOpen}
      items={items}
      index={index}
      onIndexChange={setIndex}
      angular={angular}
      onRefreshImageUrl={refreshImageUrl}
      onClose={close}
    />
  )
}
